import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface IForcePasswordUpdateParams {
  systemUserIds?: string[];
}

export interface IForcePasswordUpdateResult extends IResult {
}

export class ForcePasswordUpdateRequest extends Request<IForcePasswordUpdateParams, IForcePasswordUpdateResult> {
  constructor(params: IForcePasswordUpdateParams) {
    super('forcePasswordUpdate', params);
  }
}
